import { createContext, useContext } from "react";

export const GuestContext = createContext({
  guests: [],
  setGuests: () => {},
});
export const useGuestContext = () => useContext(GuestContext);
